import { render, staticRenderFns } from "./AmetrasSelectFieldTemplate.vue?vue&type=template&id=fd2a0a6e&"
import script from "./AmetrasSelectFieldTemplate.vue?vue&type=script&lang=ts&"
export * from "./AmetrasSelectFieldTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./AmetrasSelectFieldTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VAutocomplete,VCombobox})
